import request from "@/utils/request";

export default function openCloseNewsCreatedTime(id, isShowCreatedTime) {
    return request({
        url: `/news/agency/openCloseNewsCreatedTime/`+id+`/`+isShowCreatedTime,
        method: 'get',
    })
}
